"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCoords = exports.findItemByID = exports.makeGenericNetworkReducer = exports.makeIfNeededAction = exports.networkAction = exports.networkActionTypes = exports.assetIdToBytesUrl = exports.downloadVersionBundle = exports.fetchStationRevision = exports.fetchRevision = exports.fetchOtt = exports.makeAuthHeaders = exports.ACCESS_TOKEN_MANAGE = exports.ACCESS_TOKEN_READ = exports.setLocalStorageJSON = exports.getLocalStorageJSON = exports.detailTitle = exports.timestampToString = exports.getFalse = exports.nop = exports.id = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var proj4_1 = __importDefault(require("proj4"));
var config_1 = require("./config");
var id = function (x) { return x; };
exports.id = id;
var nop = function () { };
exports.nop = nop;
var getFalse = function () { return false; };
exports.getFalse = getFalse;
var timestampToString = function (timestamp) {
    return timestamp ? (new Date(timestamp)).toLocaleString() : undefined;
};
exports.timestampToString = timestampToString;
var detailTitle = function (prefix, titleProp) {
    return function (obj, initialFetchDone, isFetching) {
        return (!initialFetchDone && isFetching)
            ? "Loading..."
            : (obj
                ? react_1.default.createElement("span", null, prefix ? "".concat(prefix, ": ").concat(obj === null || obj === void 0 ? void 0 : obj[titleProp]) : obj === null || obj === void 0 ? void 0 : obj[titleProp])
                : "".concat(prefix, " not found"));
    };
};
exports.detailTitle = detailTitle;
var getLocalStorageJSON = function (k) {
    if (!k) {
        return {};
    }
    var ls = localStorage.getItem(k);
    return ls ? JSON.parse(ls) : {};
};
exports.getLocalStorageJSON = getLocalStorageJSON;
var setLocalStorageJSON = function (k, v) {
    if (!k)
        return;
    localStorage.setItem(k, JSON.stringify(v));
};
exports.setLocalStorageJSON = setLocalStorageJSON;
exports.ACCESS_TOKEN_READ = {
    audience: config_1.AUTH_AUDIENCE,
    scope: "read:content",
};
exports.ACCESS_TOKEN_MANAGE = {
    audience: config_1.AUTH_AUDIENCE,
    scope: "manage:content",
};
var makeAuthHeaders = function (accessToken) {
    return !accessToken ? {} : { "Authorization": "Bearer ".concat(accessToken) };
};
exports.makeAuthHeaders = makeAuthHeaders;
var fetchOtt = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var req;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(config_1.API_BASE_URL, "/ott"), {
                    method: "POST",
                    headers: (0, exports.makeAuthHeaders)(accessToken),
                })];
            case 1:
                req = _a.sent();
                if (!req.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, req.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                console.error("Failed to get OTT", req);
                return [2 /*return*/, null];
        }
    });
}); };
exports.fetchOtt = fetchOtt;
var fetchRevision = function (objectsType) {
    return function (objectID, revisionID, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
        var req;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(config_1.API_BASE_URL, "/").concat(objectsType, "/").concat(objectID, "/revision/").concat(revisionID), {
                        headers: (0, exports.makeAuthHeaders)(accessToken),
                    })];
                case 1:
                    req = _a.sent();
                    if (!req.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, req.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    console.error("Failed to get revision", req);
                    return [2 /*return*/, null];
            }
        });
    }); };
};
exports.fetchRevision = fetchRevision;
exports.fetchStationRevision = (0, exports.fetchRevision)("stations");
var downloadVersionBundle = function (version, isAuthenticated, getAccessTokenSilently) {
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken, ott;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAuthenticated)
                        return [2 /*return*/];
                    return [4 /*yield*/, getAccessTokenSilently({
                            audience: config_1.AUTH_AUDIENCE,
                            scope: "read:content",
                        })];
                case 1:
                    accessToken = _a.sent();
                    return [4 /*yield*/, (0, exports.fetchOtt)(accessToken)];
                case 2:
                    ott = _a.sent();
                    if (!ott)
                        return [2 /*return*/];
                    window.location.href = "".concat(config_1.API_BASE_URL, "/releases/").concat(version !== null && version !== void 0 ? version : "", "/bundle?ott=").concat(ott.token);
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.downloadVersionBundle = downloadVersionBundle;
var assetIdToBytesUrl = function (assetId) { return "".concat(config_1.API_BASE_URL, "/assets/").concat(assetId, "/bytes"); };
exports.assetIdToBytesUrl = assetIdToBytesUrl;
var networkActionTypes = function (name) { return ({
    REQUEST: "".concat(name, ".REQUEST"),
    RECEIVE: "".concat(name, ".RECEIVE"),
    ERROR: "".concat(name, ".ERROR"),
}); };
exports.networkActionTypes = networkActionTypes;
var networkAction = function (types, url, method) {
    if (method === void 0) { method = "GET"; }
    return function (body, params, accessToken) {
        if (params === void 0) { params = {}; }
        if (accessToken === void 0) { accessToken = ""; }
        return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
            var authHeaders, urlParams, r, data, err, error_1, err;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ params: params, type: types.REQUEST });
                        authHeaders = (0, exports.makeAuthHeaders)(accessToken);
                        urlParams = method === "GET" ? (Object.keys(params).length ? new URLSearchParams(params) : null) : null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(config_1.API_BASE_URL + url + (urlParams ? "?".concat(urlParams.toString()) : ""), __assign({ method: method }, (body instanceof FormData ? {
                                // Don't set content type manually for uploading multipart/form-data
                                headers: authHeaders,
                                body: body,
                            } : __assign({ headers: __assign({ "Content-Type": "application/json" }, authHeaders) }, (body && Object.keys(body).length ? { body: JSON.stringify(body) } : {})))))];
                    case 2:
                        r = _a.sent();
                        return [4 /*yield*/, r.json()];
                    case 3:
                        data = _a.sent();
                        if (r.ok) {
                            dispatch({ type: types.RECEIVE, data: data, params: params });
                            return [2 /*return*/, { error: false, data: data }];
                        }
                        else {
                            err = "Request to ".concat(url, " encountered error status: ").concat(data.message);
                            antd_1.message.error(err);
                            dispatch({
                                params: params,
                                type: types.ERROR,
                                message: err,
                            });
                            return [2 /*return*/, { error: true, message: err }];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        err = "Request to ".concat(url, " encountered thrown error: ").concat(error_1.toString());
                        antd_1.message.error(err);
                        dispatch({ type: types.ERROR, message: err });
                        return [2 /*return*/, { error: true, message: err }];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    };
};
exports.networkAction = networkAction;
// TODO: proper types for reducer - keys of getState
var makeIfNeededAction = function (action, reducer) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (dispatch, getState) {
        var _a, _b, _c, _d;
        if (((_a = getState()[reducer]) === null || _a === void 0 ? void 0 : _a.isFetching) ||
            ((_b = getState()[reducer]) === null || _b === void 0 ? void 0 : _b.isAdding) ||
            ((_c = getState()[reducer]) === null || _c === void 0 ? void 0 : _c.isUpdating) ||
            ((_d = getState()[reducer]) === null || _d === void 0 ? void 0 : _d.isDeleting))
            return;
        return dispatch(action.apply(void 0, args));
    };
}; };
exports.makeIfNeededAction = makeIfNeededAction;
// interface GenericNetworkReducerState {
//   initialFetchDone: boolean;
//   isFetching: boolean;
//   isAdding: boolean;
//   isUpdating: boolean;
//   isDeleting: boolean;
//   // TODO: how to express items/data
//   items?: object[];
//   data?: object;
//   error: string;
// }
var makeGenericNetworkReducer = function (fetchTypes, addTypes, updateTypes, deleteTypes, idKey, isArrayData) {
    if (addTypes === void 0) { addTypes = undefined; }
    if (updateTypes === void 0) { updateTypes = undefined; }
    if (deleteTypes === void 0) { deleteTypes = undefined; }
    if (idKey === void 0) { idKey = "id"; }
    if (isArrayData === void 0) { isArrayData = true; }
    return function (state, action) {
        var _a, _b;
        if (state === void 0) { state = __assign(__assign({ initialFetchDone: false, isFetching: false, isAdding: false, isUpdating: false, isDeleting: false }, (isArrayData ? { items: [], itemsByID: {} } : { data: null })), { error: "" }); }
        switch (action.type) {
            case fetchTypes.REQUEST:
                return __assign(__assign({}, state), { isFetching: true });
            case fetchTypes.RECEIVE:
                return __assign(__assign(__assign(__assign({}, state), { isFetching: false, initialFetchDone: true }), (isArrayData
                    ? ({
                        items: action.data,
                        itemsByID: Object.fromEntries(action.data.map(function (d) { return [d[idKey], d]; }))
                    }) : { data: action.data })), { error: "" });
            case fetchTypes.ERROR:
                return __assign(__assign({}, state), { isFetching: false, error: action.message });
        }
        if (addTypes) {
            switch (action.type) {
                case addTypes.REQUEST:
                    return __assign(__assign({}, state), { isAdding: true });
                case addTypes.RECEIVE:
                    return __assign(__assign(__assign(__assign({}, state), { isAdding: false }), (isArrayData
                        ? ({
                            items: __spreadArray(__spreadArray([], state.items, true), [action.data], false),
                            itemsByID: __assign(__assign({}, state.itemsByID), (_a = {}, _a[action.data[idKey]] = action.data, _a)),
                        }) : { data: action.data })), { error: "" });
                case addTypes.ERROR:
                    return __assign(__assign({}, state), { isAdding: false, error: action.message });
            }
        }
        if (updateTypes) {
            switch (action.type) {
                case updateTypes.REQUEST:
                    return __assign(__assign({}, state), { isUpdating: true });
                case updateTypes.RECEIVE:
                    return __assign(__assign(__assign(__assign({}, state), { isUpdating: false }), (isArrayData
                        ? ({
                            items: state.items.map(function (i) { return i[idKey] === action.data[idKey] ? action.data : i; }),
                            itemsByID: __assign(__assign({}, state.itemsByID), (_b = {}, _b[action.data[idKey]] = action.data, _b)),
                        }) : { data: action.data })), { error: "" });
                case updateTypes.ERROR:
                    return __assign(__assign({}, state), { isUpdating: false, error: action.message });
            }
        }
        if (deleteTypes) {
            switch (action.type) {
                case deleteTypes.REQUEST:
                    return __assign(__assign({}, state), { isDeleting: true });
                case deleteTypes.RECEIVE:
                    return __assign(__assign(__assign(__assign({}, state), { isDeleting: false }), (isArrayData
                        ? ({
                            items: state.items.filter(function (i) { return i[idKey] !== action.params.id; }),
                            itemsByID: Object.fromEntries(Object.entries(state.itemsByID)
                                .filter(function (e) { return e[0] !== action.params.id; })),
                        }) : { data: null })), { error: "" });
                case deleteTypes.ERROR:
                    return __assign(__assign({}, state), { isDeleting: false, error: action.message });
            }
        }
        return state;
    };
};
exports.makeGenericNetworkReducer = makeGenericNetworkReducer;
var findItemByID = function (items, id, idKey) {
    if (idKey === void 0) { idKey = "id"; }
    return items.find(function (obj) { var _a; return ((_a = obj[idKey]) !== null && _a !== void 0 ? _a : "").toString() === id.toString(); });
};
exports.findItemByID = findItemByID;
var transformCoords = function (_a) {
    var zone = _a.zone, east = _a.east, north = _a.north, _b = _a.crs, crs = _b === void 0 ? "WGS84" : _b;
    var _c = (0, proj4_1.default)("+proj=utm +zone=".concat(zone), "+proj=longlat +ellps=".concat(crs, " +datum=").concat(crs, " +no_defs"), [east, north]), longitude = _c[0], latitude = _c[1];
    return { longitude: longitude, latitude: latitude };
};
exports.transformCoords = transformCoords;
